module.exports = __webpack_public_path__ + "static/media/play-boss-lose-2.dfc42452.png";